import { EventState, SET_EVENTS, SetEventsAction } from './types';

const initialState = {
    byIds: {},
};

export default function eventQeueReducer(state: EventState = initialState, action: SetEventsAction): EventState {
    switch (action.type) {
        case SET_EVENTS: {
            const payload = action.payload || {};
            return {
                ...state,
                byIds: {
                    ...state.byIds,
                    [payload.id]: { id: payload.id, data: payload.data },
                },
            };
        }
        default:
            return state;
    }
}
